/**
* author: duxin
* date: 2020/4/7
* describe: 首页轮播图
*/

<template>
    <ElCarousel :autoplay="true" @change="onChange"  :interval="7000">
        <ElCarouselItem>
            <div class="image-wrap">
                <div class="image-nav image-nav-1">
                </div>
                <p class="text-1">
                    <transition name="title-small">
                        <span class="span-1" v-show="currentIndex===0">{{$t("home.banner1")}}</span>
                    </transition>
                    <br/>
                    <transition name="title-large">
                        <span v-show="currentIndex===0">{{$t("home.banner2")}}</span>
                    </transition>
                </p>
            </div>
        </ElCarouselItem>
        <ElCarouselItem>
            <div class="image-wrap" @click="onNewBook">
                <div class="image-nav  image-nav-2"
                     src="../../../assets/book_20200409171519(1).jpg">
                </div>
                <p class="text-1">
                    <br/>
                    <transition name="title-large-new">
                        <span v-show="currentIndex===1">{{$t("menu.book")}}</span>
                    </transition>
                </p>
            </div>
        </ElCarouselItem>
        <ElCarouselItem v-if="lastImg">

            <div class="image-wrap" @click="onNews">
                <img class="image-nav"
                     :src="lastImg">
                <p class="text-1 news-text">
                    <br/>
                    <transition name="title-large-new">
                        <span class="title-last" v-show="currentIndex===2&&lastTitle && lastTitle.length">{{lastTitle}}</span>
                    </transition>
                </p>
            </div>
        </ElCarouselItem>
    </ElCarousel>
</template>

<script>
    import {GetPublicView} from '../../../api/web'

    export default {
        name: "banner-chunk",
        data() {
            return {
                currentIndex: -1,
                lastImg: '',
                lastTitle: '',

            }
        },
        mounted() {
            this.currentIndex = 0;
            this.init()
        },
        methods: {
            init() {
                GetPublicView({companyId: 1}).then(res => {
                    if (res.status && res.data) {
                        this.lastImg = res.data.imageUrl;
                        this.lastTitle = res.data.newsTitle;
                        this.newsId = sessionStorage.getItem("language") == 'en' ? res.data.enNewsId : res.data.newsId;
                    }
                })
            },
            onNewBook() {
                this.$router.push("/info/book")
            },
            onNews() {
                if (this.newsId)
                this.$router.push({name: "WEB", query: {newsId: this.newsId}})
            },
            onChange(value) {
                this.currentIndex = value
            }
        }
    }
</script>

<style lang="less" scoped>
    @import "../../../style/constant.less";

    .image-wrap {
        position: relative;
        cursor: pointer;
        height: 100%;

        .text-1 {
            position: absolute;
            z-index: 10;
            left: 0;
            right: 0;
            top: 30%;
            color: #3e3e3e;
            font-size: 60px;
            text-align: center;
            letter-spacing: 5px;

            span {
                display: inline-block;
            }

            .span-1 {
                font-size: 30px;
            }
        }

        @media screen and (min-width: 320px) and (max-width: 480px) {
            .text-1 {
                font-size: 24px;

                .span-1 {
                    font-size: 18px;
                }
            }
        }
    }

    .title-last {
        font-size: 32px;
        background-color: rgba(255, 255, 255, 0.51);
        min-height: 60px;
        padding: 30px;
        max-width: 60%;
        text-align: center;
    }

    /deep/ .el-carousel__container {
        height: 70vh;
    }

    @media screen and (min-width: 320px) and (max-width: 480px) {
        /deep/ .el-carousel__container {
            height: 40vh;
        }
        .title-last{
            font-size: 24px!important;
            max-width: 80%;
        }
        .news-text{
            top: 10% !important;
        }
    }

    .image-nav {
        width: 100%;
        height: 100%;
        object-fit: fill;
    }
    .image-nav-1{
        background: url("../../../assets/h9-slider-image-1b.jpg") no-repeat center;
        background-size: cover;
    }
    .image-nav-2{
        background: url("../../../assets/book_20200409171519(1).jpg") no-repeat center;
        background-size: cover;
    }
    @media screen and (min-width: 320px) and (max-width: 480px) {
        .image-nav-1{
            background: url("../../../assets/image-1.png") no-repeat center;
            background-size: cover;
        }
        .image-nav-2{
            background: url("../../../assets/image-2.png") no-repeat center;
            background-size: cover;
        }
    }

    .title-small-enter {
        transform: translateY(10px);
        opacity: 0;
    }

    .title-small-enter-active {
        transition: all .5s .4s;
    }

    .title-large-enter {
        transform: translateY(30px);
        opacity: 0;
    }

    .title-large-enter-active {
        transition: all .5s .8s;
    }

    .title-large-new-enter {
        transform: translateY(30px);
        opacity: 0;
    }

    .title-large-new-enter-active {
        transition: all .5s .5s;
    }

</style>
